// extracted by mini-css-extract-plugin
export default {"switch":"DeliverableSwitch_switch__dftMJ"};